import { useMemo } from 'react';
import { ArrowForwardIcon } from 'src/client/components/common/icons';

type Props = {
  title: string;
  value: string[] | undefined | null;
  onClick: () => void;
  arrowIcon: boolean;
  dataTestId?: string;
};

export const trimString = (value: string[] | undefined | null) => {
  const text = typeof value === 'string' ? value : value?.join(', ') || '';

  return text.length > 14 ? `${text.substr(0, 14)} ...` : text;
};

export const ModalInput = ({ title, value, onClick, arrowIcon, dataTestId }: Props) => {
  const selectedValueText = useMemo(() => {
    return trimString(value);
  }, [value]);
  return (
    <>
      <div
        className="w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray"
        data-testid={dataTestId}
        onClick={onClick}
      >
        <span className="text-sm font-normal text-black">{title}</span>
        <div className="inline-flex items-center justify-between gap-4">
          {value && value.length > 0 ? (
            <span>{selectedValueText}</span>
          ) : (
            <span className="text-font-gray">選択なし</span>
          )}
          {arrowIcon ? <ArrowForwardIcon width={18} /> : null}
        </div>
      </div>
    </>
  );
};
